var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFixedRand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 495",
    cx: 40.0072,
    cy: 40.0072,
    r: 40.0072,
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 3 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0071 25.8622C37.0222 25.8622 34.9203 28.2277 34.9203 30.501V35.6226H31.1914V30.501C31.1914 25.8475 35.2098 22 40.0071 22C42.5191 22 44.744 23.1721 46.318 24.7227C47.8593 26.2411 49.0052 28.357 49.0052 30.501V35.6226H45.2763V30.501C45.2763 29.7274 44.8008 28.5583 43.7481 27.5212C42.7281 26.5163 41.3862 25.8622 40.0071 25.8622Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1395",
    x: 28.5,
    y: 36.8281,
    width: 23.0376,
    height: 19.6719,
    rx: 2.69152,
    stroke: "#E60000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    d: "M36.4307 52.3888V41.9099H40.6462C41.4797 41.9099 42.1903 42.072 42.778 42.3962C43.3764 42.7099 43.7931 43.1126 44.0282 43.6041C44.2633 44.0956 44.3809 44.6133 44.3809 45.1571C44.3809 45.8474 44.2099 46.4069 43.8679 46.8356C43.5367 47.2644 43.1306 47.5834 42.6498 47.7925C43.0451 47.9076 43.339 48.1063 43.5313 48.3886C43.7237 48.6606 43.8946 49.0632 44.0443 49.5965L44.8136 52.3888H42.0567L41.3995 50.1142C41.2713 49.5913 41.095 49.2462 40.8706 49.0789C40.6569 48.9011 40.3684 48.8122 40.005 48.8122H39.1235V52.3888H36.4307ZM39.1235 46.569H40.1493C40.6943 46.569 41.0736 46.4748 41.2873 46.2866C41.5117 46.0879 41.6239 45.8003 41.6239 45.4238C41.6239 45.0264 41.5171 44.7283 41.3034 44.5296C41.0896 44.3309 40.7103 44.2316 40.1653 44.2316H39.1235V46.569Z",
    fill: "#E60000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixedRand);
export default __webpack_public_path__ + "static/media/fixed-rand.05d96704fa52e44282cf914192b53067.svg";
export { ForwardRef as ReactComponent };